import React, { useState, useEffect } from 'react';
import Layout from '../layout/Layout';
import { TbLoader3 } from 'react-icons/tb';
import { FaChevronRight, FaEye } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

import {
    Accordion,
    AccordionHeader,
    AccordionBody,
    Checkbox,
    Dialog,
    DialogBody
} from "@material-tailwind/react";
import { BiSolidCart } from 'react-icons/bi';

function Icon({ open }) {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
}

const Remate = () => {
    const queryParams = new URLSearchParams(location.search);
    const [loader, setLoader] = useState(true);
    const [data, setData] = useState({ departamentoRow: [] });
    const [error, setError] = useState(null);
    const [selectedDeptos, setSelectedDeptos] = useState([]);

    const [openModal, setOpenModal] = useState(false);
    const [qty, setQty] = useState(1);
    const [dataPopup, setDataPopup] = useState(null);

    const handleOpenModal = (dataProd) => {
        setDataPopup(dataProd);
        setOpenModal(!openModal);
        setQty(1);
    };

    useEffect(() => {
        setLoader(true);
        setError(null);
        const url = new URL("https://muebleria-villarreal.com/apimv/remateController.php");
        fetch(url)
        .then(response => response.json())
        .then(data => {
            console.log(data);
            if (data.error) {
                setError(data.error);
                setData({ departamentoRow: [] });
            } else {
                setData(data);
                setError(null);
            }
            setLoader(false);
        })
        .catch(error => {
            console.log(error);
            setError('Error al cargar los datos');
            setData({ departamentoRow: [] });
            setLoader(false);
        });
    }, []);

    
    
    const isCheckedDepartamento = (departamento) => {
        return selectedDeptos.includes(departamento);
    };

    const [categoriaAccordion, setCategoriaAccordion] = useState(false);

    const handleDepartamento = (departamento) => {
        setSelectedDeptos(prev => {
            if (prev.includes(departamento)) {
                return prev.filter(depto => depto !== departamento);
            } else {
                return [...prev, departamento];
            }
        });
    };

    const filteredDepartamentos = data?.departamentoRow?.filter(articulo => 
        selectedDeptos.length === 0 || selectedDeptos.includes(articulo.nom_departamento)
    );
    
    const agregarCarrito = () => {
        setOpenModal(!openModal);
        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        let inventario = Math.floor(dataPopup.exist);
    
        const productIndex = cart.findIndex(item => item.articulo === dataPopup.articulo);
    
        if (productIndex !== -1) {
            let cantidad = cart[productIndex].qty + qty;
            if(cantidad > inventario) {
                cantidad = inventario;
                // notifyInventario(inventario);
                toast.error('Solamente contamos con ' + inventario + ' articulos en el inventario.', {
                    duration: 3000
                })
            } else {
                // notify();
                toast.success('Articulo Agregado', {
                    duration: 3000
                })
            }
            cart[productIndex].qty = cantidad;
        } else {
            cart.push({
                articulo: dataPopup.articulo,
                qty: qty
            });
            toast.success('Articulo Agregado', {
                duration: 3000
            })
        }
    
        localStorage.setItem('cart', JSON.stringify(cart));
        window.dispatchEvent(new Event('cartUpdated'));
    }

    return (
        <Layout>
            <Dialog size='lg' open={openModal} handler={handleOpenModal}>
                <DialogBody className='max-h-[80lvh] overflow-y-auto'>
                    <div className="flex flex-col lg:flex-row justify-between items-center gap-5">
                        <img src={"https://s3.us-east-2.amazonaws.com/cdn.muebleriavillarreal/mvcweb/images/articulos_img/" + dataPopup?.departamento + "/" + dataPopup?.articulo + ".jpg?quality=auto&format=webp"} alt="" className={`h-48 w-full lg:h-full lg:aspect-square lg:w-5/12 object-contain rounded-lg`} />
                        <div className="flex flex-col justify-start items-start w-full lg:w-6/12 gap-2">
                            <h1 className='text-xl lg:text-2xl font-negro'>{dataPopup?.descripcion_corta}</h1>
                            <span className='text-sm text-gris font-medio'>Cod: {dataPopup?.articulo}</span>
                            <div className="flex flex-row justify-start items-end gap-2 py-2 w-full">
                                <span className='text-gris text-sm cross line-through font-medio'>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(dataPopup?.precio_lista)}</span>
                                <span className='text-rojo text-2xl lg:text-3xl cross font-negro'>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(dataPopup?.precio_contado)}</span>
                            </div>
                            <span className='text-sm text-green-600 font-medio'>Producto disponible</span>
                            <div className="flex mt-4 flex-row justify-between lg:justify-start items-center border border-azul p-2 rounded-md mb-5 w-full lg:w-fit">
                                <button className='text-dark font-negro aspect-square w-7' onClick={() => setQty(prevQty => Math.max(1, prevQty - 1))}>-</button>
                                <input type="text" className=' border-0 appearance-none text-dark text-center w-24 outline-none' min={1} value={qty}
                                    onKeyDown={(e) => {
                                        if (e.key === '.' || e.key === 'e') {
                                            e.preventDefault();
                                        }
                                    }}
                                    onFocus={() => {
                                        setQty("")
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value.trim(); // Trim the input value
                                        // Allow the value to be an empty string
                                        if (value === "") {
                                            setQty("");
                                        } else if (isNaN(value)) {
                                            setQty(1);
                                        } else {
                                            // Ensure the value is a number
                                            value = parseInt(value, 10);
                                            // Convert the value to a number
                                            value = Number(value);
                                            // Ensure the value is within the valid range
                                            value = Math.max(1, Math.min(dataPopup?.exist, value));
                                            setQty(value);
                                        }
                                    }}
                                    onBlur={(e) => {
                                        // Re-validate the input on blur
                                        let value = e.target.value;
                                        if (isNaN(value)) {
                                            value = 1;
                                        } else if(value == 0) {
                                            value = 1;
                                        } else {
                                            value = parseInt(value, 10);
                                        }
                                        value = Number(value);
                                        value = Math.max(1, Math.min(dataPopup?.exist, value));
                                        setQty(value);
                                    }}
                                />
                                <button className='text-dark font-negro aspect-square w-7' onClick={() => setQty(prevQty => Math.min(dataPopup?.exist, prevQty + 1))}>+</button>
                            </div>
                            <div className="flex flex-col lg:flex-row justify-start items-center gap-2 w-full">
                                <button className='w-full lg:w-fit bg-azul py-2 px-3 text-white text-sm rounded flex justify-center items-center gap-2' onClick={agregarCarrito}><BiSolidCart fill='white' size={20} />Agregar a Carrito</button>
                                <a href={"/Articulo/" + dataPopup?.articulo + "/" + dataPopup?.grupo} className='w-full lg:w-fit bg-link py-2 px-3 text-white text-sm rounded flex justify-center items-center gap-2'><FaEye fill='white' size={18} />Ver</a>
                            </div>
                        </div>
                    </div>
                </DialogBody>
            </Dialog>
            <section className="w-full px-[5vw] py-10 lg:py-14 relative">
                {
                    loader &&
                        <div className="w-full h-full flex justify-center items-start p-10 absolute top-0 left-0 z-20 bg-white/90">
                            <TbLoader3 className='animate-spin stroke-azul' size={50} />
                        </div>
                }
                <div className="flex flex-row justify-start items-center gap-1">
                    <a href="/" className='text-azul font-negro'>Inicio</a>
                    <FaChevronRight size={10} />
                    <p className=''>Remate</p>
                </div>
                <div className="flex flex-col lg:flex-row w-full justify-between items-start gap-10 pt-8 relative">
                    <aside className='w-full lg:w-4/12 xl:w-3/12 flex flex-col justify-start items-start relative'>
                        <h2 className='font-medio text-xl lg:text-2xl text-left border-b border-b-[#cfcfcf] w-full pb-3 tracking-tight'>Filtros</h2>
                        <Accordion open={categoriaAccordion} icon={<Icon id={1} open={categoriaAccordion} />}>
                            <AccordionHeader className='text-sm border-0 text-dark font-medio py-4' onClick={() => setCategoriaAccordion(!categoriaAccordion)}>Departamentos</AccordionHeader>
                            <AccordionBody className="py-1">
                                <div className='flex flex-col w-full justify-start items-start gap-2'>
                                    {
                                        data?.departmentNames && data.departmentNames.length > 0 ? data.departmentNames.map((departamento, index) => (
                                            <div key={index} className='text-sm font-normal checkboxCheck'>
                                                <Checkbox name='departamentoRadio' className="border-gray-900/10 bg-gray-900/5 p-0 transition-all hover:before:opacity-0" checked={isCheckedDepartamento(departamento)} onChange={() => handleDepartamento(departamento)} label={<span className='capitalize'>{departamento}</span>} />
                                            </div>
                                        )) : null
                                    }
                                </div>
                            </AccordionBody>
                        </Accordion>
                    </aside>
                    <div className='w-full flex flex-col justify-start items-start gap-5'>
                        <div className="grid grid-cols-2 xl:grid-cols-3 gap-5 w-full relative">
                            {
                                filteredDepartamentos && filteredDepartamentos.length > 0 ? filteredDepartamentos.map((articulo, index) => (
                                    <div key={index} className='relative w-full flex flex-col justify-start items-start gap-2 p-3 z-10 bg-white rounded-lg shadow transition-all hover:scale-105 hover:shadow-xl hover:z-30'>
                                        <a href={"/Articulo/" + articulo.articulo + "/" + articulo.grupo} className='relative w-full flex flex-col justify-start items-start gap-2 p-3 bg-white'>
                                            <img src={"https://s3.us-east-2.amazonaws.com/cdn.muebleriavillarreal/mvcweb/images/articulos_img/" + articulo.departamento + "/" + articulo.articulo + ".jpg?quality=auto&format=webp"} alt="" className="w-full object-cover rounded-lg aspect-square" />
                                            <h5 className='text-center lg:text-left font-negro leading-tight pt-2 text-sm lg:text-lg'>{articulo.descripcion_corta}</h5>
                                            <div className="flex flex-col lg:flex-row justify-start items-center lg:items-end lg:gap-2 pt-0 w-full">
                                                <span className='text-gris text-xs lg:text-sm cross line-through font-medio'>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(articulo.precio_lista)}</span>
                                                <span className='text-rojo lg:text-xl cross font-medio'>{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(articulo.precio_contado)}</span>
                                            </div>
                                        </a>
                                        <button className='text-xs lg:text-sm text-white text-center p-2 w-full bg-azul rounded-md relative z-10 mt-auto' onClick={() => handleOpenModal(articulo)}>
                                            Agregar
                                        </button>
                                    </div>
                                ))
                                :
                                !loader ?
                                    <div className='relative w-full flex flex-col justify-start items-center gap-1 p-4 bg-white rounded-lg column col-span-3'>
                                        <div className='size-20 rounded-full bg-azul flex justify-center items-center '>
                                            <img src="/images/iso.svg" className='w-7/12 pt-1' />
                                        </div>
                                        <h3 className='text-lg lg:text-3xl font-medio text-azul text-center pt-5'>
                                            {error ? 'Error al cargar los productos' : 'No se encontró ningún producto'}
                                        </h3>
                                        <p className='text-base text-center'>
                                            {error ? error : 'Favor de intentar nuevamente'}
                                        </p>
                                    </div>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default Remate;